import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import LoginPage from "./LoginPage";
import TwoFactorVerifyPage from "./TwoFactorVerifyPage";
import TwoFactorSetupPage from "./TwoFactorSetupPage";

const AuthWrapper = () => {

  return (
    <>
      <Routes>
        <Route path='login' element={<LoginPage/>} />
        <Route path='verify-2fa' element={<TwoFactorVerifyPage />} />
        <Route path='setup-2fa' element={<TwoFactorSetupPage />} />

        <Route path='*' element={<Navigate to="/404" replace/>}/>
        <Route index element={<Navigate to='/auth/login' />} />
      </Routes>
    </>
  )
}

export {AuthWrapper}
